import _ from 'lodash';
import { CalculatorType, Scenario } from 'spw-redux/modules/calculators/types';
import ProgramScenario, { PlainProgramScenario } from './Scenario';

export default class USFScenario extends ProgramScenario {
  targetUSFPerWorkSeat: number;

  constructor(apiScenario: Scenario, totalAvailableUSF: number) {
    super(0, apiScenario);
    this.targetUSFPerWorkSeat = apiScenario.targetUsf;
    this.totalAvailableUSF = totalAvailableUSF;
    this.totalAvailableRSF =
      this.totalAvailableUSF * (1 + apiScenario.rsfLoadFactor);

    this.updateWorkSeats();
    this.updateConcurrentHeadcount();
    this.updateHeadcountWithVacancy();
    this.updateHeadcount();
    this.workSeatsOriginal = this.workSeats;
    this.applyWorkSeatsRoundingSetting();
  }

  updateWorkSeats = () => {
    const workSeatsValue = this.totalAvailableUSF / this.targetUSFPerWorkSeat;
    this.workSeats =
      Number.isFinite(workSeatsValue) && !Number.isNaN(workSeatsValue)
        ? workSeatsValue
        : 0;
  };

  updateConcurrentHeadcount = () => {
    this.headcountWithUtilization = this.workSeats * this.deskSharingRatio;
  };

  updateHeadcountWithVacancy = () => {
    this.headcountWithVacancy =
      (this.headcountWithUtilization * 100) /
      this.headcountUtilizationPercentage;
  };

  private updateHeadcount = () => {
    this.headcount =
      this.headcountWithVacancy / (1 + this.vacancyFactorPercentage / 100);
  };

  static parseToUSFScenario(
    scenario: PlainProgramScenario,
    calculatorType: CalculatorType
  ) {
    const newScenario = _.cloneDeep(scenario);
    newScenario.calculatorType = calculatorType;
    newScenario.areStoredWorkSeatsOutdated = true;
    newScenario.storedWorkSeats = newScenario.workSeats;

    return newScenario;
  }
}
